import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import moment from 'moment'

import StadiumRemote from '../remote/stadiumRemote'
import { getActiveAttendantId } from '../selectors/attendant'
import { useDispatch, useSelector } from 'react-redux'
import { orderReportsLastFetchedAt } from '../actions/order'
import { formatTotals } from '../utils/totalUtils'

const useGetSummaryReport = () => {
  const [dataLoading, setLoading] = useState(false)
  const [dataSucceeded, setSuccess] = useState(false)
  const [dataFailed, setFailed] = useState(false)
  const [qsTotals, setQsTotals] = useState()
  const [nonQsTotals, setNonQsTotals] = useState()
  const employeeUuid = useSelector(getActiveAttendantId)
  const cancelTokenRef = useRef()
  const dispatch = useDispatch()

  useEffect(() => {
    cancelTokenRef.current = axios.CancelToken.source()

    return () => {
      cancelTokenRef.current.cancel()
    }
  }, [])

  const executeRequest = () => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    StadiumRemote.getSummaryReport(employeeUuid)
      .then((result) => {
        // qs totals is "device totals"
        const data = result?.data?.reports?.[0]

        const totals = formatTotals(data?.qsTotals ?? {})
        setQsTotals({
          ...totals,
          pendingRefundCount: data?.unappliedRefundsCount ?? 0,
          tabsCount: data?.qsTotals?.tabsCount ?? 0,
        })
        setNonQsTotals(data?.nonQsTotals)
        setLoading(false)
        setSuccess(true)
        dispatch(orderReportsLastFetchedAt(moment().format('MM/DD/YY h:mm A')))
      })
      .catch((err) => {
        if (axios.isCancel(err)) return

        setLoading(false)
        setFailed(true)
      })
  }

  // device totals and attendant totals respectively
  return [executeRequest, { qsTotals, nonQsTotals, dataLoading, dataSucceeded, dataFailed }]
}

export default useGetSummaryReport
